var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{attrs:{"dark":_vm.darkTheme}},[_c('v-main',[_c('v-container',{attrs:{"container--fluid":""}},[_c('router-view')],1)],1),_c('v-footer',{staticClass:"footer justify-center",attrs:{"height":"50"}},[_c('span',[_vm._v("Copyright Worldline © "+_vm._s(new Date().getFullYear())+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }